export default __webpack_public_path__ + "maps-guides-styles-expressions-zoom-low-1200-62c4fc523f50995cc023fe7944faf6c5.webp";